import { Container } from '@material-ui/core';
import Page from '../components/Page';
import ClientPortfolio from '../components/clients/ClientPortfolio';

export default function Blog() {
  return (
    <Page title="Dashboard: Blog | ZIMTA">
      <Container>
        <ClientPortfolio />
      </Container>
    </Page>
  );
}
